.brand-navigation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(5, 5, 5, 0.9);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--color-border);
  z-index: 100;
  padding: var(--space-4) 0;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-brand {
  font-family: var(--font-heading);
  font-size: var(--font-size-xl);
  font-weight: bold;
}

.nav-links {
  list-style: none;
  display: flex;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
}

@media (min-width: 768px) {
  .nav-links {
    gap: var(--space-6);
  }
}

.nav-links a {
  font-size: var(--font-size-sm);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.nav-links a:hover,
.nav-links a:focus {
  color: var(--color-text-primary);
  outline: none;
}

.nav-links a:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 4px;
}
